import React from 'react';
import PropTypes from 'prop-types';
import Logo from 'components/ui/logo/logo';
import {gameUiTexts} from 'data/ui-texts';
import {getText} from 'helpers/text-helper';
import './loading-page.scss';

const LoadingPage = ({languageId}) => {
	return (
		<div className='LoadingPage'>
			<div className="LoadingPage-logo"><Logo /></div>
			<div className="LoadingPage-subtitle">
				<span>{getText(gameUiTexts.subtitle, languageId)}</span>
			</div>
			<div className="LoadingPage-text"><span>{getText(gameUiTexts.loadingGame, languageId)}</span></div>
		</div>
	);
};

LoadingPage.propTypes = {
	languageId: PropTypes.string.isRequired,
};

export default LoadingPage;